import { CSSProperties } from "react"
import { Lightbulb, NanoEnergiesLogoHorizontal } from "../../../images/xd/icons"
import { CSSProp, styled, theme } from "../../../styles/stitches.config"

export const SNanoGreenLogo = styled(NanoEnergiesLogoHorizontal, {
  height: theme.sizes.s6,
  width: theme.sizes.s24,
  display: "block",
})

export const SPricePointsContainer = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  gap: theme.space.s4,
  flexShrink: 0,

  "@md": {
    flexDirection: "column",
    justifyContent: "initial",
    gap: theme.space.s6,
  },
})

export const SLightBulb = styled(Lightbulb, {
  width: theme.sizes.s8,
  height: theme.sizes.s8,
  color: theme.colors.textsAlt,
  flexShrink: 0,

  "@md": {
    width: theme.sizes.s5,
    height: theme.sizes.s5,
  },
})

export const SDisclaimer = styled("a", {
  display: "flex",
  alignItems: "center",
  gap: theme.space.s4,

  backgroundColor: theme.colors.lines,
  borderRadius: theme.radii.default,
  boxShadow: theme.shadows.default,
  padding: theme.space.s4,
})

export const SPriceInfoContainer = styled("div", {
  "@md": {
    paddingRight: theme.space.s4,
    width: theme.sizes.s56,
  },

  variants: {
    popOut: {
      true: {
        paddingRight: theme.space.s4,
        backgroundColor: theme.colors.white,
        borderRadius: theme.radii.default,

        paddingTop: theme.space.s4,
        paddingLeft: theme.space.s4,
        paddingBottom: theme.space.s4,

        boxShadow: theme.shadows.default,

        "@md": {
          borderRadius: theme.sizes.s40,
        },
      },
      false: {},
    },
  },

  defaultVariants: {
    popOut: false,
  },
})

export const SPriceInfoContent = styled("div", {
  display: "flex",
  gap: theme.space.s6,
  alignItems: "center",
  flexDirection: "column",

  "@md": {
    flexDirection: "row",
  },

  variants: {
    padded: {
      true: {
        "@md": {
          paddingLeft: theme.space.s4,
        },
      },
      false: {},
    },
  },

  defaultVariants: {
    padded: true,
  },
})

export const SContent = styled("div", {
  paddingLeft: theme.space.s3,
  paddingRight: theme.space.s3,

  "@sm": {
    paddingLeft: theme.space.s24,
    paddingRight: theme.space.s24,
  },

  variants: {
    layout: {
      mobile: {
        paddingLeft: theme.space.s3,
        paddingRight: theme.space.s3,
      },
      desktop: {
        maxWidth: theme.sizes.s220,
        margin: "0 auto",
        paddingLeft: "unset",
        paddingRight: "unset",
      },
    },
  },

  defaultVariants: {
    layout: "mobile",
  },
})

export const SMobileHeaderContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.space.s4,
  gap: theme.space.s4,
})

export const headerStyles: CSSProp = {
  fontSize: theme.sizes.s6,
  flexShrink: 0,
}

export const anchorContainerStyle: CSSProperties = {
  position: "absolute",
  top: theme.space.s15.value,
  right: theme.space.s4.value,
}
